<template>
  <div class="flex flex-col overflow-hidden h-full">
    <before-login v-if="!isLogin" :departmentStatus="departmentStatus" />

    <template v-if="isLogin">
      <after-login :departmentStatus="departmentStatus" />

      <template
        v-if="!getConfigJs.isClosed && !getConfigJs.isContinueChatEnabled"
      >
        <TextMessage
          v-if="getConfigJs.isTakeOver && getConfigJs.isChatAreaEnabled"
        />
      </template>
    </template>
  </div>
</template>

<script>
import AfterLogin from "@/components/customer/body/AfterLogin";
import BeforeLogin from "@/components/customer/body/BeforeLogin";
import TextMessage from "@/components/customer/sendMessage";
import { db } from "@/common/firebase/init";
import { waktu, request, alert } from "@/common/mixins/mix_helper";
import { departemenStatus } from "@/common/config";
import { mapGetters } from "vuex";

export default {
  name: "BodyBase",
  mixins: [waktu, request, alert],
  props: {
    isLogin: {
      required: true,
      type: Boolean,
    },
  },
  components: {
    AfterLogin,
    BeforeLogin,
    TextMessage,
  },
  data() {
    return {
      departmentStatus: departemenStatus,
    };
  },
  computed: {
    ...mapGetters(["getConfigJs"]),
  },
  created() {
    /**
     * --------------------------------------------------------------
     * listen firebase department status on/off
     * --------------------------------------------------------------
     */
    db.ref("others/department-status").on("value", (status) => {
      this.departmentStatus = status.val();
    });
  },
};
</script>
